import React, { Component } from 'react';
import classnames from 'classnames';
import Helmet from 'react-helmet';
import { graphql, useStaticQuery } from 'gatsby';
import Menu from './Menu';
import Footer from './Footer';

import '../styles/variables.css';
import './Layout.css';
import grid from '../styles/grid.module.css';

const Layout = props => {
	const { children, title, className } = props;
	const data = useStaticQuery(graphql`
		query SiteTitleQuery {
			site {
				siteMetadata {
					title
				}
			}
		}
	`);

	return (
		<div className={'layout--root'}>
			<Helmet title={title ? `${title} — ${data.site.siteMetadata.title}` : data.site.siteMetadata.title}>
				<html lang="en" />
			</Helmet>
			<Menu siteTitle={data.site.siteMetadata.title} invert={props.invert} />
			{className ? <main className={className}>{children}</main> : <main>{children}</main>}

			<Footer />
		</div>
	);
};

export default Layout;
